<template>
  <section class="video">
    <div class="container">
      <div
        data-aos="fade-down"
        data-aos-duration="2000"
        style="text-align: center"
        class="aos-init aos-animate"
      >
        <a
          href="https://www.youtube.com/watch?v=DzSMKVz89L0&feature=youtu.be"
          target="_blank"
        >
          <img
            loading="lazy"
            :src="require('@/assets/images/video_thumb.png')"
            class="videothumb"
            alt="Renter Insurance Explainer Video for College Students Dorm Room Insurnace"
          />
        </a>
        <br /><br /><br /><br /><br /><br />
      </div>
      <div style="clear: both"></div>
    </div>
  </section>
</template>
